import { render, staticRenderFns } from "./create-refund-address.vue?vue&type=template&id=189b065c&scoped=true"
import script from "./create-refund-address.vue?vue&type=script&lang=ts"
export * from "./create-refund-address.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "189b065c",
  null
  
)

export default component.exports